var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'alert-icon type_'+_vm.type},[_c('i',{class:'alert-icon cl-icon cl-icon-'+_vm.type})])}
var staticRenderFns = []

export { render, staticRenderFns }